import React, { useState } from "react";
import "./../../../../assets/css/general/blog/BlogHero/BlogHero.css";

const BlogHero = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const categories = [
    "All",
    "Frontend",
    "Backend",
    "AI & ML",
    "Career",
    "Roadmaps",
    "Interview Prep",
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchQuery);
  };

  return (
    <section className="blog-hero">
      <div className="blog-hero-container">
        <div className="blog-hero-content">
          <div className="blog-hero-left">
            <span className="blog-hero-label">TECH INSIGHTS</span>
            <h1 className="blog-hero-heading">
              Learn. Build. Grow{" "}
              <span className="blog-hero-prefix">in Tech.</span>
            </h1>
            <p className="blog-hero-subtext">
              Explore practical tutorials, coding guides, AI insights, and
              career roadmaps written by mentors and industry professionals.
            </p>
          </div>

          <div className="blog-hero-right">
            <div className="blog-hero-decoration">
              <div className="blob blob-1"></div>
              <div className="blob blob-2"></div>
            </div>
          </div>
        </div>

        <div className="blog-hero-search-section">
          <form className="blog-search-form" onSubmit={handleSearch}>
            <div className="search-input-wrapper">
              <svg
                className="search-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input
                type="text"
                className="search-input"
                placeholder="Search articles, topics, technologies..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                aria-label="Search blog articles"
              />
            </div>
            <button type="submit" className="search-button">
              Search
            </button>
          </form>

          <div className="category-pills-wrapper">
            <div className="category-pills">
              {categories.map((category) => (
                <button
                  key={category}
                  type="button"
                  className={`category-pill ${activeCategory === category ? "active" : ""}`}
                  onClick={() => setActiveCategory(category)}
                  aria-label={`Filter by ${category}`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
